import { render } from "./payments.vue?vue&type=template&id=9dc0b99a&scoped=true"
import script from "./payments.vue?vue&type=script&lang=js"
export * from "./payments.vue?vue&type=script&lang=js"

import "./payments.vue?vue&type=style&index=0&id=9dc0b99a&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/cleanshift_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dc0b99a"]])

export default __exports__